import * as React from 'react'

import Main from './Main'
import history from '../history'

export default class App extends React.Component {
  componentDidMount () {
    // force an update if the URL changes
    history.listen(() => this.forceUpdate())
  }

  render () {
    return <Main />
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/App.tsx